import { ChipsideComponent } from "../chipside-component";

export class Progress extends ChipsideComponent {
	parsedCallback() {
		const list = document.createElementWithContents("ol");
		list.append(...[...this.querySelectorAll(":scope > chip-progressitem")].map(x => document.createElementWithContents("li", x, { className: x.active ? "progress-item--active" : "" })));

		this.appendChild(list);
	}
}